var $d7f8e6da366bff75$exports = {};
document.querySelectorAll('.sidebar li a').forEach((element)=>{
    element.classList.remove('bg-active', 'text-active-text');
});
document.querySelectorAll('.sidebar li:nth-child(7) a').forEach((element)=>{
    element.classList.add('bg-active', 'text-active-text');
}); // import("./breadcrumbs.js").then(function (breadcrumb) {
 //     breadcrumb.setCrumbs({
 //         1: {
 //             href: "series.html",
 //             text: "Series"
 //         },
 //         2: {
 //             href: "",
 //             text: "GT3 Endurance"
 //         }
 //     });
 // });


//# sourceMappingURL=caterham-420r-cup-2026-season-4.b4ae710b.js.map
